/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Err_Cannot_Drop_Own_AdminInputs */

const vi_user_err_cannot_drop_own_admin = /** @type {(inputs: User_Err_Cannot_Drop_Own_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể bỏ vai trò Quản trị viên của chính bạn`)
};

/**

* @param {User_Err_Cannot_Drop_Own_AdminInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_err_cannot_drop_own_admin = /** @type {((inputs?: User_Err_Cannot_Drop_Own_AdminInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Err_Cannot_Drop_Own_AdminInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_err_cannot_drop_own_admin(inputs)
});